import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_767_2049)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.7226 19.8299V16.8588H20.33L17.089 12.0376H19.5358L16.6898 8.01839H18.6651L14.392 1.02832L10.1229 8.01839H12.0982L9.25608 12.0376H11.7029L8.45774 16.8588H14.0651V19.8299H4.81358V18.4956C6.84531 18.3263 8.44576 16.6211 8.44576 14.5449C8.44576 12.36 6.668 10.5823 4.48314 10.5823C2.29821 10.5823 0.520508 12.3601 0.520508 14.5449C0.520508 16.6211 2.12089 18.3261 4.15269 18.4956V19.8299H0.520508V20.491H20.9991V19.8299H14.7226ZM4.15278 17.8304C2.48789 17.6652 1.18168 16.2542 1.18168 14.545C1.18168 12.7229 2.66516 11.2435 4.48322 11.2435C6.30532 11.2435 7.78475 12.7269 7.78475 14.545C7.78475 16.2542 6.47865 17.6651 4.81366 17.8304V15.8632H4.15255L4.15278 17.8304ZM14.0615 16.1978H9.69579L12.941 11.3765H10.5303L13.3724 7.35736H11.3003L14.3922 2.29422L17.484 7.35736H15.412L18.2541 11.3765H15.8433L19.0885 16.1978H14.7228V13.8839H14.0617L14.0615 16.1978Z",
    fill: "black"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_767_2049" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "20.6398",
      height: "20.6398",
      fill: "white",
      transform: "translate(0.44043 0.439941)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }